import { yupResolver } from '@hookform/resolvers/yup';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { ProgressButton } from 'components';
import { hasPath, path } from 'ramda';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { useChangePasswordMutation } from 'store/api/version-api.slice';

import ACCOUNT_INFO_SCHEMA from './accountInfo.schema';

const PASSWORD_FORM_DEFAULT_VALUES = {
	password1: '',
	password2: ''
};

const ChangePasswordDialog = ({ isOpen, togglePassDialog }) => {
	const passwordFormMethods = useForm({
		defaultValues: PASSWORD_FORM_DEFAULT_VALUES,
		resolver: yupResolver(ACCOUNT_INFO_SCHEMA)
	});

	const [changePassword, { isLoading: isChangePasswordLoading }] = useChangePasswordMutation();

	const {
		handleSubmit,
		control,
		formState: { errors: passwordFormErrors }
	} = passwordFormMethods;

	const updatePassword = async data => {
		await changePassword(data);

		togglePassDialog();
	};

	return (
		<Dialog open={isOpen} onClose={togglePassDialog} maxWidth={'md'} fullWidth={true}>
			<DialogTitle>Change Password</DialogTitle>
			<FormProvider {...passwordFormMethods}>
				<form onSubmit={handleSubmit(updatePassword)}>
					<DialogContent>
						<Grid container spacing={2}>
							<Grid item xs={6} sm={6} marginBottom="8px">
								<Controller
									name="password1"
									control={control}
									render={({ field }) => (
										<TextField
											fullWidth
											type="password"
											variant="outlined"
											label="New Password"
											{...field}
											helperText={path(['password1', 'message'], passwordFormErrors)}
											error={hasPath(['password1', 'message'], passwordFormErrors)}
										/>
									)}
								/>
							</Grid>
							<Grid item xs={6} sm={6}>
								<Controller
									name="password2"
									control={control}
									render={({ field }) => (
										<TextField
											fullWidth
											variant="outlined"
											label="Confirm Password"
											type="password"
											{...field}
											helperText={path(['password2', 'message'], passwordFormErrors)}
											error={hasPath(['password2', 'message'], passwordFormErrors)}
										/>
									)}
								/>
							</Grid>
						</Grid>
					</DialogContent>
					<DialogActions>
						<Button variant={'contained'} onClick={togglePassDialog} sx={{ backgroundColor: '#e0e0e0' }}>
							Cancel
						</Button>
						<ProgressButton
							isLoading={isChangePasswordLoading}
							button={
								<Button variant={'contained'} color={'primary'} type={'submit'}>
									Save
								</Button>
							}
							circleColor={'secondary'}
						/>
					</DialogActions>
				</form>
			</FormProvider>
		</Dialog>
	);
};

export default ChangePasswordDialog;
